import type { ReactNode } from "react";

import type { LegalDocumentType } from "@tinkr/shared/legal";

/** Docs-portal anchors of the legal documents. */
export const LEGAL_DOC_ANCHORS: Record<LegalDocumentType, string> = {
  terms_of_service: "terms-of-service",
  privacy_policy: "privacy-policy"
};

/**
 * Render a translated template containing `{terms}` / `{privacy}` tokens,
 * replacing each token with a docs-portal link. Token-based so translators
 * control word order (and RTL locales flow naturally).
 *
 * Lives apart from LegalAcceptanceGate so the public signup form can use it
 * without pulling the console gate into the entry chunk (ADR-WES1).
 */
export function renderLegalConsentText(
  template: string,
  labels: { terms: string; privacy: string }
): ReactNode {
  const nodes: ReactNode[] = [];
  const pattern = /\{(terms|privacy)\}/g;
  let cursor = 0;
  let match: RegExpExecArray | null;
  let key = 0;
  while ((match = pattern.exec(template)) !== null) {
    if (match.index > cursor) {
      nodes.push(template.slice(cursor, match.index));
    }
    const token = match[1] as "terms" | "privacy";
    nodes.push(
      <a
        href={`/docs#${token === "terms" ? LEGAL_DOC_ANCHORS.terms_of_service : LEGAL_DOC_ANCHORS.privacy_policy}`}
        key={key++}
        rel="noreferrer"
        target="_blank"
      >
        {labels[token]}
      </a>
    );
    cursor = match.index + match[0].length;
  }
  if (cursor < template.length) {
    nodes.push(template.slice(cursor));
  }
  return nodes;
}
